import { ENV } from '../envs';
import { isVa } from '@meego/utils/src/platform/environment';
import Cookies from 'js-cookie';

export const HOST = ENV.host;
export const GO_HOST = ENV.hostForGo;
export const GUIDE_LINK = ENV.guideLink;
export const BFF_HOST = HOST + '/bff';

// 解析获取 SLD
export const SLD = /*#__PURE__*/ (() =>
  HOST.match(/((http|https):\/\/)?(.+\.)?(.+\.(cn|com))/)?.[4])();

const larkDomainUnit: Record<string, string> = {
  eu_ea: 'https://project-va.larksuite.com',
  larkjpaws: 'https://project-jp.larksuite.com',
  larksgaws: 'https://project-sg.larksuite.com',
};

const meegleDomainUnit: Record<string, string> = {
  eu_ea: 'https://va.meegle.com',
  larkjpaws: 'https://jp.meegle.com',
  larksgaws: 'https://sg.meegle.com',
};

export const getAPIHost = (): string => {
  if (!isVa) return HOST;

  const { hostname } = window.location;

  const meegoTargetUnit = Cookies.get('meego_target_unit') || '';

  if (hostname === 'project.larksuite.com') {
    return larkDomainUnit[meegoTargetUnit] || HOST;
  }

  if (hostname === 'meegle.com') {
    return meegleDomainUnit[meegoTargetUnit] || HOST;
  }

  return HOST;
};

export const getCookieDomain = (): string | undefined => {
  if (!isVa) return undefined;

  return `.${SLD}`;
};
